import React from "react";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import EmailIcon from "@material-ui/icons/Email";
import PersonIcon from "@material-ui/icons/Person";
import CakeIcon from "@material-ui/icons/Cake";
import WcIcon from "@material-ui/icons/Wc";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

import WorkIcon from "@material-ui/icons/Work";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import BusinessIcon from "@material-ui/icons/Business";
import HomeIcon from "@material-ui/icons/Home";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import FaceIcon from "@material-ui/icons/Face";
import SchoolIcon from "@material-ui/icons/School";
import FavoriteIcon from "@material-ui/icons/Favorite";
import DescriptionIcon from "@material-ui/icons/Description";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import ContactsIcon from "@material-ui/icons/Contacts";
import PaymentIcon from "@material-ui/icons/Payment";
import TimerOutlinedIcon from "@material-ui/icons/TimerOutlined";
import EventAvailableOutlinedIcon from "@material-ui/icons/EventAvailableOutlined";
import PhotoCameraOutlinedIcon from "@material-ui/icons/PhotoCameraOutlined";
import CreditCardOutlinedIcon from "@material-ui/icons/CreditCardOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import WorkOutlineOutlinedIcon from "@material-ui/icons/WorkOutlineOutlined";

export const maritalStatusList = [
  { value: "SINGLE", label: "Single" },
  { value: "MARRIED", label: "Married" },
  { value: "DIVORCED", label: "Divorced" },
];

export const idNumberDocumentsList = [{ value: "pan", label: "PAN Card" }];
export const educationTypeList = [
  { value: "Post Graduate", label: "Post Graduate" },
  { value: "Graduate", label: "Graduate" },
  { value: "Engneering", label: "Engneering" },
  { value: "CA/CS/CFA", label: "CA/CS/CFA" },
  { value: "Diploma", label: "Diploma" },
  { value: "Diploma", label: "Diploma" },
  { value: "Non Graduate", label: "Non Graduate" },
];

export const professionTypeList = [
  { value: "Listed Company Employee", label: "Listed Company Employee" },
  { value: "Central Govt Employee", label: "Central Govt Employee" },
  { value: "State Govt Employee", label: "State Govt Employee" },
  { value: "Central PSU Employee", label: "Central PSU Employee" },
  { value: "State PSU Employee", label: "State PSU Employee" },
  { value: "Private Company Employee", label: "Private Company Employee" },
  { value: "Private Firm Employee", label: "Private Firm Employee" },
];

export const residanceTypeList = [
  { value: "Self Owned", label: "Self Owned" },
  { value: "Spouse/Children owned", label: "Spouse/Children Owned" },
  { value: "Company provided", label: "Company Provided" },
  { value: "Rented/leased", label: "Rented/Leased" },
];

export const accountTypeList = [
  { value: "savings", label: "Saving" },
  { value: "current", label: "Current" },
];

export const purposeOfLoanList = [
  { value: "Personal Needs", label: "Personal Needs" },
  { value: "Medical Expenses", label: "Medical Expenses" },
  { value: "Travel/Vacation Expenses", label: "Travel/Vacation Expenses" },
  { value: "Repayment of Loan", label: "Repayment Of Loan" },
  { value: "Marriage Expenses", label: "Marriage Expenses" },
  { value: "Education Needs", label: "Education Needs" },
];

export const welcomeWhyChooseUS = [
  {
    title: "Instant Approval",
    icon: <TimerOutlinedIcon fontSize="large" />,
    description:
      "Experience fast processing and reliable support for all your financial needs.",
  },
  {
    title: "Low Interest Rates",
    icon: <MonetizationOnOutlinedIcon fontSize="large" />,
    description:
      "Flexible, competitive rates designed to keep your EMI manageable.",
  },
  {
    title: "100% Online Process",
    icon: <VerifiedUserOutlinedIcon fontSize="large" />,
    description:
      "Complete your loan application digitally without visiting a branch.",
  },
  {
    title: "Flexible EMI Options",
    icon: <EventAvailableOutlinedIcon fontSize="large" />,
    description:
      "Choose a repayment schedule that fits your monthly budget.",
  },
];

export const welcomeFeatures = [
  {title:"Loan amount from ₹50,000 to ₹2 Lakhs"},
  {
    title:"Interest Rates ranging from 24% to 36% per annum"
  },
  {title:"Tenure ranging from 2 months to 60 months"},
  {title:"Processing fee up to 10% + GST"},
  {title:"Quick & direct transfer to the Bank Account"},
  {title:"No collateral or pledge of security"}
]
export const welcomeApplicationRequirementsLeft = [
  { label: "Mobile Number", icon: <PhoneAndroidIcon fontSize="small" /> },
  { label: "Email", icon: <EmailIcon fontSize="small" /> },
  { label: "First & Last Name", icon: <PersonIcon fontSize="small" /> },
  { label: "Date of Birth", icon: <CakeIcon fontSize="small" /> },
  { label: "Gender", icon: <WcIcon fontSize="small" /> },
  { label: "PAN", icon: <CreditCardIcon fontSize="small" /> },
  { label: "Employment Type", icon: <WorkIcon fontSize="small" /> },
  { label: "Monthly Income", icon: <AttachMoneyIcon fontSize="small" /> },
  { label: "Company Name", icon: <BusinessIcon fontSize="small" /> },
  { label: "Address Proof", icon: <HomeIcon fontSize="small" /> },
  { label: "PAN Photo", icon: <CameraAltIcon fontSize="small" /> },
  { label: "Selfie", icon: <FaceIcon fontSize="small" /> },
];

// Right Data
export const welcomeApplicationRequirementsRight = [
  { label: "Permanent Address", icon: <HomeIcon fontSize="small" /> },
  { label: "Current Address", icon: <HomeIcon fontSize="small" /> },
  { label: "Education", icon: <SchoolIcon fontSize="small" /> },
  { label: "Profession", icon: <WorkIcon fontSize="small" /> },
  { label: "Marital Status", icon: <FavoriteIcon fontSize="small" /> },
  { label: "Employment Proof", icon: <DescriptionIcon fontSize="small" /> },
  { label: "Bank Statement", icon: <AccountBalanceIcon fontSize="small" /> },
  {
    label: "Father/Mother/Spouse Name",
    icon: <FavoriteIcon fontSize="small" />,
  },
  { label: "Reference Contact", icon: <ContactsIcon fontSize="small" /> },
  {
    label: "Disbursement Bank Account",
    icon: <AccountBalanceIcon fontSize="small" />,
  },
  { label: "eNACH/UPI e-mandate", icon: <PaymentIcon fontSize="small" /> },
];

export const documentItems = [
  {
    label: "Photograph",
    icon: <PhotoCameraOutlinedIcon fontSize="large" />,
  },
  {
    label: "PAN Card",
    icon: <CreditCardOutlinedIcon fontSize="large" />,
  },
  {
    label: "Address Proof",
    icon: <HomeOutlinedIcon fontSize="large" />,
  },
  {
    label: "Income Proof",
    icon: <DescriptionOutlinedIcon fontSize="large" />,
  },
  {
    label: "Employment Proof",
    icon: <WorkOutlineOutlinedIcon fontSize="large" />,
  },
];

export const welcomeEligibilityList = [
  "Indian Citizen",
  "Age 21 years and above",
  "Minimum monthly personal income of ₹15,000",
  "Valid identity proof & address proof",
  "Aadhaar-linked mobile number",
  "Minimum 3 months of work experience.",
];

export const welcomeOtherFeesCharges = [
  {
    icon: <PaymentIcon fontSize="small" />,
    title: "Foreclosure charges",
    details:
      "NO FORECLOSURE CHARGES",
  },
  {
    icon: <PaymentIcon fontSize="small" />,
    title: "Part-Prepayment Charges",
    details:
      "No charges in case of part or full prepayment.",
  },
  {
    icon: <CreditCardIcon fontSize="small" />,
    title: "Penal & eNach Return Charges ",
    details:
      "Penal charges Rs. 200 per day and eNach return charges Rs. 500 per instant.",
  },
  // {
  //   icon: <AttachMoneyIcon fontSize="small" />,
  //   title: "Credit Information Report Fees",
  //   details:
  //     "Credit Information Report Fees of ₹50 + GST is applied if the customer opts for receiving their Credit Information Report. This fee is disclosed upfront in the KFS.",
  // },
  {
    icon: <DescriptionIcon fontSize="small" />,
    title: "Retained Processing Fees in case of cool-off",
    details:
      "A percentage of the one-time processing fee may be retained as the cool off fee if the customer exits during the cooling-off period. The exact amount is disclosed upfront in the KFS.",
  },
  {
    icon: <AccountBalanceIcon fontSize="small" />,
    title: "Stamp Duty",
    details:
      "Stamp duty charges as per actuals shall be applied based on the disbursement office/branch. The exact amount is disclosed upfront in the KFS.",
  },
  {
    icon: <WorkIcon fontSize="small" />,
    title: "Maintenance & Procurement Cost",
    details:
      "Maintenance & Procurement Cost may be applied based on the disbursement office/branch. The exact amount is disclosed upfront in the KFS.",
  },
];

export const welcomePurposeList = [
  { title: "Medical" },
  { title: "Travel" },
  { title: "Shopping" },
  { title: "Education" },
  { title: "Renovation" },
  { title: "Business" },
];

export const InstallmentTable = [
  { id: "label", label: "Sr. No." },
  { id: "principalAmount", label: "Principal Amount" },
  { id: "openingBalance", label: "Opening Balance" },
  { id: "interestAmount", label: "Interest Amount" },
  { id: "installmentAmount", label: "Installment Amount" },
  { id: "date", label: "Due Date" },
];

export const loanSchemeDetailTable = [
  { id: "adjustment", label: "Adjustment" },
  { id: "adjustedAmount", label: "Adjusted Amount" },
  { id: "adjustedAmountWithoutGst", label: "Adjusted Amount With out GST" },
  { id: "cgstAmount", label: "Cgst Amount" },
  { id: "chargeType", label: "Charge Type" },
  { id: "excludingGst", label: "Excluding Gst" },
  { id: "gstApplicable", label: "GST Applicable" },
  { id: "igstAmount", label: "Igst Amount" },
  { id: "sgstAmount", label: "Sgst Amount" },
];

export const receiptPurposeTypeList = [
  { value: "ANY_DUE", label: "Any Due" },
  { value: "ADVANCE_EMI", label: "Advance Installment" },
  { value: "CLOSURE", label: "Closure" },
  { value: "EMI", label: "Installment" },
  { value: "FEE_AND_CHARGE", label: "Fee And Charge" },
  { value: "PART_PREPAYMENT", label: "Part Prepayment" },
];

export const repaymentTypeList = [
  { value: "EMI", label: "Change In Installment " },
  { value: "TERM", label: "Change In Tenure" },
  // { value: "EMI_DATE", label: "Change In Installment Date" },
];

export const emiScheduleList = [
  { id: "label", label: "Sr. No." },
  { id: "principalAmount", label: "Installment" },
  { id: "date", label: "Due Date" },
  { id: "paid", label: "Paid" },
];

export const bankOptions = [
  { value: 'Abhyudaya Co-Operative Bank Ltd', label: 'Abhyudaya Co-Operative Bank Ltd' },
  { value: 'ACME BANK', label: 'ACME BANK' },
  { value: 'Airtel Payments Bank', label: 'Airtel Payments Bank' },
  { value: 'Allahabad Bank', label: 'Allahabad Bank' },
  { value: 'Andhra Bank', label: 'Andhra Bank' },
  { value: 'AP GRAMEENA VIKAS BANK', label: 'AP GRAMEENA VIKAS BANK' },
  { value: 'AU Small Finance Bank', label: 'AU Small Finance Bank' },
  { value: 'Axis Bank', label: 'Axis Bank' },
  { value: 'Bandhan Bank', label: 'Bandhan Bank' },
  { value: 'Bank of Baroda', label: 'Bank of Baroda' },
  { value: 'Bank of India', label: 'Bank of India' },
  { value: 'Bank of Maharashtra', label: 'Bank of Maharashtra' },
  { value: 'Canara Bank', label: 'Canara Bank' },
  { value: 'Central Bank of India', label: 'Central Bank of India' },
  { value: 'Citibank', label: 'Citibank' },
  { value: 'CITY UNION BANK LTD', label: 'CITY UNION BANK LTD' },
  { value: 'Corporation Bank', label: 'Corporation Bank' },
  { value: 'CSB Bank Ltd.', label: 'CSB Bank Ltd.' },
  { value: 'Dbs Bank', label: 'Dbs Bank' },
  { value: 'DCB Bank', label: 'DCB Bank' },
  { value: 'Dena Bank', label: 'Dena Bank' },
  { value: 'Dhanlaxmi Bank', label: 'Dhanlaxmi Bank' },
  { value: 'Equitas Small Finance Bank', label: 'Equitas Small Finance Bank' },
  { value: 'Esaf Small Finance Bank', label: 'Esaf Small Finance Bank' },
  { value: 'Federal Bank', label: 'Federal Bank' },
  { value: 'Fincare Small Finance Bank', label: 'Fincare Small Finance Bank' },
  { value: 'Fino Payments Bank', label: 'Fino Payments Bank' },
  { value: 'FinShareBankServer', label: 'FinShareBankServer' },
  { value: 'Finvu Bank Ltd', label: 'Finvu Bank Ltd' },
  { value: 'Finvu GSTN', label: 'Finvu GSTN' },
  { value: 'GP Parsik Bank', label: 'GP Parsik Bank' },
  { value: 'HDFC Bank', label: 'HDFC Bank' },
  { value: 'ICICI Bank', label: 'ICICI Bank' },
  { value: 'IDBI Bank', label: 'IDBI Bank' },
  { value: 'IDFC FIRST Bank', label: 'IDFC FIRST Bank' },
  { value: 'India Post Payments Bank', label: 'India Post Payments Bank' },
  { value: 'Indian Bank', label: 'Indian Bank' },
  { value: 'Indian Overseas Bank', label: 'Indian Overseas Bank' },
  { value: 'IndusInd Bank', label: 'IndusInd Bank' },
  { value: 'Jammu&Kashmir Bank', label: 'Jammu&Kashmir Bank' },
  { value: 'Jana Small Finance Bank', label: 'Jana Small Finance Bank' },
  { value: 'Janata Sahakari Bank Ltd.', label: 'Janata Sahakari Bank Ltd.' },
  { value: 'kallapana awade Bank', label: 'kallapana awade Bank' },
  { value: 'Kalyan Janata Sahakari Bank Ltd.', label: 'Kalyan Janata Sahakari Bank Ltd.' },
  { value: 'Karnataka Bank', label: 'Karnataka Bank' },
  { value: 'Karnataka Vikas Grameena Bank', label: 'Karnataka Vikas Grameena Bank' },
  { value: 'Karur Vysya Bank', label: 'Karur Vysya Bank' },
  { value: 'Kotak Mahindra Bank', label: 'Kotak Mahindra Bank' },
  { value: 'Municipal Bank', label: 'Municipal Bank' },
  { value: 'NKGSB Bank', label: 'NKGSB Bank' },
  { value: 'Oriental Bank of Commerce', label: 'Oriental Bank of Commerce' },
  { value: 'Paytm Payments Bank', label: 'Paytm Payments Bank' },
  { value: 'Post Office Saving Bank', label: 'Post Office Saving Bank' },
  { value: 'Punjab and Sind Bank', label: 'Punjab and Sind Bank' },
  { value: 'Punjab National Bank', label: 'Punjab National Bank' },
  { value: 'Rajasthan Marudhara Gramin Bank', label: 'Rajasthan Marudhara Gramin Bank' },
  { value: 'RBL (Ratnakar) Bank', label: 'RBL (Ratnakar) Bank' },
  { value: 'Saraswat co-operative Bank Ltd', label: 'Saraswat co-operative Bank Ltd' },
  { value: 'Sarva Haryana Gramin Bank', label: 'Sarva Haryana Gramin Bank' },
  { value: 'Sarvodaya Commercial Co-Operactive Bank Limited', label: 'Sarvodaya Commercial Co-Operactive Bank Limited' },
  { value: 'Setu FIP', label: 'Setu FIP' },
  { value: 'Shamrao Vithal Co-op. Bank Ltd.', label: 'Shamrao Vithal Co-op. Bank Ltd.' },
  { value: 'South Indian Bank', label: 'South Indian Bank' },
  { value: 'Standard Chartered Bank', label: 'Standard Chartered Bank' },
  { value: 'State Bank of India', label: 'State Bank of India' },
  { value: 'Syndicate Bank', label: 'Syndicate Bank' },
  { value: 'Tamilnad Mercentile Bank Ltd.', label: 'Tamilnad Mercentile Bank Ltd.' },
  { value: 'Telangana State Co-operative Apex Bank Ltd.', label: 'Telangana State Co-operative Apex Bank Ltd.' },
  { value: 'Thane Janata Sahakari Bank', label: 'Thane Janata Sahakari Bank' },
  { value: 'THE COSMOS CO-OP. BANK LTD', label: 'THE COSMOS CO-OP. BANK LTD' },
  { value: 'Tripura Gramin Bank', label: 'Tripura Gramin Bank' },
  { value: 'UCO Bank', label: 'UCO Bank' },
  { value: 'Ujjivan Bank', label: 'Ujjivan Bank' },
  { value: 'Union Bank of India', label: 'Union Bank of India' },
  { value: 'United Bank of India', label: 'United Bank of India' },
  { value: 'Utkarsh Small Finance Bank', label: 'Utkarsh Small Finance Bank' },
  { value: 'Vijaya Bank', label: 'Vijaya Bank' },
  { value: 'Yes Bank', label: 'Yes Bank' }
];

export const fieldLabels = {
  maskedAdhaarNumber: "Aadhaar Number",
  fatherName: "Father Name",
  dob: "Date of Birth",
  houseNumber: "House Number",
  street: "Street",
  locality: "Locality",
  villageTownCity: "City",
  postOffice: "Post Office",
  state: "State",
  district: "District",
  pincode: "Pincode",
};
export const thirdPartyIntegrationVendorNames = {
  digio:"DIGIO",
  digitap:"DIGITAP",
};
export const thirdPartyIntegrationNames = {
  faceLiveNess:"FACELIVENESS",
  faceMatch:"FACEMATCH",
}

export const status = {
  success: "success",
  failure:"failure",
  error:"error",
  inprogress:"inprogress",
  completed:"completed"
}

export const faviconUrl = 'https://ifl-app.s3.ap-south-1.amazonaws.com/logos/32x32+px.png'

export const dashboardTableColumns = [
    { id: "id", label: "S. No." },
    { id: "leadId", label: "Lead Id" },
    { id: "created", label: "Created By" },
    { id: "createdOn", label: "Created On" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    // { id: "maxEligibleLoanAmount", label: "Max Eligible Amount" },
    { id: "status", label: "Status" },
    { id: "action", label: "Action" },
  ];

export const incomeDetailsValidations = {
  minSalary: 15000,
  minAge: 21,
  maxAge: 55,
}

export const demoLoanList = [
  { value: "current", label: "Current Lead" },
  { value: "APP003", label: "Approved" },
  { value: "APP004", label: "Process to bank" },
  { value: "APP0ddg03", label: "Reject" },
];

export const adminPanelTableColumns = [
    // { id: "id", label: "S. No." },
    { id: "leadId", label: "Lead Id" },
    { id: "created", label: "Created By" },
    { id: "createdOn", label: "Created On" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id:"maxEligibleLoanAmount", label:"Max Eligible Amount"},
    { id: "action", label: "Action" },
  ];
export const mandateStatusList = {
  success: ["AUTH_SUCCESS", "APPLICANT_AUTH_SUCCESS", "COMPLETED"],
  failed: ["AUTH_FAILED", "REJECTED", "CANCELLED", "REVOKED", "EXPIRED"],
  inprogress: ["PARTIAL"],
}

export const enableGetTheAppButton = true

 export const adminPortalTableColumns = [
        "Lead Id",
        "Loan Account Number",
        "Created Date",
        "Customer Id",
        "Customer Name",
        "Mobile Number",
        "Status",
  ];

export const enableIvr = true

export const adminPannelData = [
      { id: "leadid", label: "Loan Application ID" },
      { id: "created", label: "Created By" },
      { id: "accountNumber", label: "Loan Account Number" },
      { id: "customerid", label: "Customer Id" },
      { id: "mobile", label: "Mobile Number" },
      { id:"status", label:"Status"},
      { id: "action", label: "Action" },
]

export const applicationStatusList = [
  { value: "INPROCESS", label: "In Process" },
  { value: "APPROVED", label: "Approved" },
  { value: "SUBMITTED", label: "Submitted" },
  { value: "LEAD_REPAYMENT_SCHEDULE", label: "Repayment Schedule" },
  { value: "LEAD_SANCTION_ESIGN", label: "Sanction Esign" },
  { value: "COMPLETED", label: "Completed" },
  { value: "REJECTED", label: "Rejected" },
];

export const leadAssignedTable = [
  { id: "leadId", label: "Lead ID"},
  { id: "loanAccountNumber", label: "Loan Account Number"},
  { id: "customerId", label: "Customer ID"},
  { id: "customerName",label: "Customer Name"},
  { id: "mobileNumber",label: "Mobile Number"},
  { id: "leadStatus", label: "Lead Status"},
  { id: "assignedTo", label: "Assigned To"},
];